module.exports = __webpack_public_path__ + "static/img/gojoinfedbfc9.jpg";